export function normalizePresentationToken(value) {
    return `${value ?? ''}`
        .trim()
        .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
        .replace(/[\s_]+/g, '-')
        .toLowerCase();
}
export function normalizeLayoutPreset(value) {
    const normalized = normalizePresentationToken(value);
    return normalized === 'active-brands' ? 'compact-mobile' : normalized;
}
export function isCompactMobileLayout(value) {
    return normalizeLayoutPreset(value) === 'compact-mobile';
}
export function normalizeProductCardPresentation(value) {
    const normalized = normalizePresentationToken(value);
    if (normalized === 'active-brands' || normalized === 'active-brands-carousel') {
        return 'compact-carousel';
    }
    if (normalized === 'compact' || normalized === 'compressed') {
        return 'horizontal-compact';
    }
    if (normalized === 'list' || normalized === 'stacked' || normalized === 'vertical-list' || normalized === 'vertical-stacked') {
        return 'vertical-list';
    }
    if (normalized === 'carousel' || normalized === 'vertical-carousel-view') {
        return 'vertical-carousel';
    }
    return normalized;
}
